import React ,{useEffect}from 'react';
import PersonalDetailsForm from './PersonalDetailsForm';
import ContactDetailsForm from './ContactDetailsForm';
import EducationalDetailsForm from './EducationalDetailsForm';
import AdditionalDetailsForm from './AdditionalDetailsForm';
import ExperienceForm from "./ExperienceForm";
import PreviewForm from './PreviewForm';
import {useDispatch, useSelector } from 'react-redux';
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import { useNavigate } from "react-router-dom";

export default function MultiStepOnboardingForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
const InviteData = useSelector((state) => state.persistedReducer.forms.inviteData);
  const paramId = InviteData?.id;
  
  const { getInvitedUserDetailsById} = useSelector(
    (state) => state.getInvitedUserDetailsById
  );

  useEffect(() => {
    if (paramId) {
      dispatch(fetchgetInvitedUserDetailsById(paramId));
    }
  }, [dispatch, paramId]);

  useEffect(() => {
    const status = getInvitedUserDetailsById?.documentUploadStatus;
    if (!status) return;
    const allowedStatuses = ['PENDING', 'PARTIAL_COMPLETED', 'SENT_BACK_FOR_REVISION'];

    if (!allowedStatuses.includes(status)) {
      console.log('allowedStatuses',allowedStatuses)
      navigate('/email-verification', { replace: true });
    }
  }, [getInvitedUserDetailsById, navigate]);
  

  const step = useSelector((state) => state?.preOnboardingForm?.step);
  return (
    <>
      {step === 1 && <PersonalDetailsForm />}
      {step === 2 && <ContactDetailsForm />}
      {step === 3 && <EducationalDetailsForm />}
      {step === 4 && <ExperienceForm />}
      {step === 5 && <AdditionalDetailsForm />}
      {step === 6 && <PreviewForm />}
    </>
  )
}
